import { Box, styled } from '@mui/material';

export const OnboardingTileContainer = styled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '800px',
  width: '530px',
  height: '80%',
  borderRadius: '8px',
  backgroundColor: '#FFF',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
}));

export const OnboardingTileTaskCard = styled(Box)<{ clickable?: boolean }>(({ theme, clickable }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '70px',
  width: '100%',
  borderRadius: '8px',
  fontSize: '16px',
  lineHeight: '20px',
  fontWeight: 600,
  backgroundColor: theme.palette.info.main,
  padding: theme.spacing(2),
  cursor: clickable ? 'pointer' : 'default',
  pointerEvents: clickable ? 'all' : 'none',
  color: !clickable && theme.palette.secondary.main,
}));

export const OnboardingTasksContainer = styled(Box)(({ theme }) => ({
  height: '70%',
  display: 'flex',
  padding: theme.spacing(2),
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
}));

export const OnboardingTileTopBlock = styled(Box)(({ theme }) => ({
  height: '5%',
  backgroundColor: '#66BA72',
  borderRadius: '8px 8px 0 0',
  position: 'relative',
}));
